import { lazy } from "react";
import { dashboardRoutes } from "etl/types";

const Dashboard = lazy(() =>
	import("etl/design-system/templates/Dashboard").then(({ Dashboard }) => ({
		default: Dashboard,
	}))
)

export const DashboardRouter = [
	{
		path: dashboardRoutes.dashboard.pathWithoutPrefix,
		component: <Dashboard />,
	},
]
